/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumesubscriptionconfirmdescription3Inputs */

const en_resumesubscriptionconfirmdescription3 = /** @type {(inputs: Resumesubscriptionconfirmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription will continue and you will be charged at the end of the current billing period.`)
};

const de_resumesubscriptionconfirmdescription3 = /** @type {(inputs: Resumesubscriptionconfirmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Abonnement wird fortgesetzt und du wirst am Ende des aktuellen Abrechnungszeitraums belastet.`)
};

/**
* | output |
* | --- |
* | "Your subscription will continue and you will be charged at the end of the current billing period." |
*
* @param {Resumesubscriptionconfirmdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resumesubscriptionconfirmdescription3 = /** @type {((inputs?: Resumesubscriptionconfirmdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumesubscriptionconfirmdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resumesubscriptionconfirmdescription3(inputs)
	return de_resumesubscriptionconfirmdescription3(inputs)
});
export { resumesubscriptionconfirmdescription3 as "resumeSubscriptionConfirmDescription" }